export default "__VITE_PUBLIC_ASSET__9ccfde1d__"